import * as React from 'react';
const SvgPlan = (props) => (
  <svg viewBox="0 0 120 123" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      clipPath="url(#plan_svg__a)"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round">
      <path d="m108.829 67.712-4.553 4.512M108.829 111.232l-4.553-4.505M64.861 111.232l4.553-4.505M64.861 67.712l4.553 4.512M86.845 57.957v7.124M118.725 89.475h-7.199M54.966 89.475h7.198M86.845 72.016c-9.398 0-18.752 7.735-17.93 18.336.313 3.975 2.054 7.875 4.413 10.715 5.368 6.467 4.743 5.849 4.916 9.029h17.202c.166-3.18-.453-2.562 4.916-9.029 2.359-2.84 4.099-6.74 4.412-10.715.828-10.607-8.531-18.337-17.93-18.337ZM78.244 110.102v3.118c0 4.707 3.858 8.524 8.614 8.524 4.788 0 8.652-3.861 8.607-8.6l-.019-3.042M24.802 11.585H1.275v97.041h55.439M63.293 11.585h23.52l.032 39.4" />
      <path d="M56.178 7.736h-3.475a8.996 8.996 0 0 0-8.658-6.474 8.996 8.996 0 0 0-8.659 6.474h-3.475c-4.667 0-8.454 3.748-8.454 8.367v5.994h41.169v-5.994c0-4.619-3.787-8.367-8.455-8.367h.007ZM39.734 43.09h27.442M20.97 43.135l3.214 4.442 8.32-8.973M39.734 60.714h27.442M20.97 60.758l3.214 4.436 8.32-8.966M55.495 78.332h-15.76M20.97 78.376l3.214 4.442 8.32-8.973" />
    </g>
    <defs>
      <clipPath id="plan_svg__a">
        <path fill="#fff" d="M0 0h120v123H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPlan;
